import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scoped.css';
import iconErrorLarge from 'src/assets/large_red_close.svg';
import Button, { ButtonTypes } from 'src/components/Button';

export interface PopupConfirmProps {
  visible: boolean;
  children?: React.ReactNode;
  title?: string;
  content?: string;
  onOk?: () => void;
  okTitle?: string;
  okButtonComponent?: React.ReactNode;
  onCancel?: () => void;
  cancelTitle?: string;
  redConfirm?: boolean;
  type?: '';
  showContactButton?: boolean;
  showIcon?: boolean;
  okButtonType?: ButtonTypes;
  isHtmlContent?: boolean;
  popupStyle?: React.CSSProperties;
  buttonContainerStyle?: React.CSSProperties;
  hotline?: string;
  icon?: string;
}

const PopupConfirm = (props: PopupConfirmProps) => {
  const { t } = useTranslation();
  const {
    visible,
    children,
    onOk,
    onCancel,
    title,
    content,
    okTitle,
    cancelTitle,
    okButtonComponent,
    showContactButton = false,
    showIcon = true,
    okButtonType = ButtonTypes.primaryFilled,
    isHtmlContent,
    popupStyle,
    buttonContainerStyle,
    hotline = t('hotline'),
    icon = iconErrorLarge
  } = props;

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [visible]);

  if (!visible) return <div />;
  return (
    <div className="popupModal">
      <div
        className="relative p-6 bg-white w-full max-w-md m-auto flex-col flex rounded-lg items-center"
        style={popupStyle}
      >
        {showIcon && (
          <div className={'pt-4 pb-7'}>
            <img src={icon} className="w-20 h-20" />
          </div>
        )}
        <div>
          <p className="largeTitleText text-center">{title}</p>
        </div>
        {children ? (
          <div>{children}</div>
        ) : (
          <div className="pt-3 pb-8">
            {!isHtmlContent ? (
              <p className="popupContentText text-center">{content}</p>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            )}
          </div>
        )}
        <div
          className="flex flex-col space-y-4 w-full"
          style={buttonContainerStyle}
        >
          {!!onCancel && (
            <Button
              onClick={onCancel}
              text={cancelTitle ? cancelTitle : t('cancel')}
              extraClassName={'w-full'}
              // leftIcon={<img src={iconCloseRed} className="mr-2" />}
              buttonType={ButtonTypes.errorBorderless}
            />
          )}
          {okButtonComponent ? (
            okButtonComponent
          ) : showContactButton ? (
            <a href={`tel:${hotline}`}>
              <Button
                onClick={onOk}
                text={t('contact_now')}
                extraClassName={'w-full'}
                buttonType={okButtonType}
              />
            </a>
          ) : (
            !!onOk && (
              <Button
                onClick={onOk}
                text={okTitle ? okTitle : t('ok')}
                extraClassName={'w-full'}
                buttonType={okButtonType}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};
export default PopupConfirm;
